export default __webpack_public_path__ + "static/media/MS-Sans-Serif.4fb9ed0f.woff2";